import { call, put, select, take } from 'redux-saga/effects';
import axios from 'axios';
import {
  SET_TOTAL_LIKES,
  UPDATE_TOTAL_LIKES,
  RECORD_ERROR_SAGA,
} from '../actions';

/* Selector: where does the token live in Redux? */
const getSessionToken = (s: any) =>
  s.auth?.sessionToken ?? s.session?.apiToken ?? null;

const totalLikesEndpoint =
  'https://www.yisumatica.org.il/yisumaticaApi/getTotalLikes.php';

function* getTotalLikes(): Generator<any, any, any> {
  while (true) {
    /* 1⃣  Wait until someone dispatches GET_TOTAL_LIKES_SAGA */
    yield take('GET_TOTAL_LIKES_SAGA');

    /* 2⃣  Ensure we actually have a token */
    let token: string | undefined = yield select(getSessionToken);
    if (!token) {
      /* pause saga until SET_API_TOKEN comes in */
      yield take('SET_API_TOKEN');
      token = yield select(getSessionToken);
    }

    try {
      /* ---------- DEVELOPMENT ---------- */
      if (process.env.NODE_ENV === 'development') {
        yield put(SET_TOTAL_LIKES([]));     // mock array if you like
        yield put(UPDATE_TOTAL_LIKES());
        continue;
      }

      /* ---------- PRODUCTION ---------- */
      const res = yield call(
        axios.post,
        totalLikesEndpoint,
        null,
        {
          withCredentials: true,
          // If you kept the Bearer-token model, uncomment next line:
          // headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (res?.data?.success) {
        yield put(SET_TOTAL_LIKES(res.data.result ?? []));
        yield put(UPDATE_TOTAL_LIKES());
      } else {
        throw new Error('likes call failed');
      }
    } catch (err) {
      console.error('GET_TOTAL_LIKES_SAGA error:', err);
      yield put(
        RECORD_ERROR_SAGA({
          data: { error: err },
          endpoint: 'GET_TOTAL_LIKES_SAGA',
        }),
      );
    }
  }
}

export default getTotalLikes;
